export const EQUIPMENT_CERTIFICATIONS_CHART_ENDPOINT = '/certificate-api/chart/v1/equipment-certifications';
